import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=keyboard&selected=Material+Symbols+Rounded:keyboard_double_arrow_left:FILL@0;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const KeyboardDoubleArrowLeftIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Keyboard Double Arrow Left Icon</title>;
    t1 = <path d="M7.59424 12L11.652 16.073C11.7903 16.2115 11.8637 16.383 11.872 16.5875C11.8803 16.792 11.807 16.9718 11.652 17.127C11.507 17.2718 11.3313 17.3442 11.125 17.3442C10.9187 17.3442 10.743 17.2718 10.598 17.127L6.10399 12.6327C6.01033 12.5391 5.94424 12.4403 5.90574 12.3365C5.86724 12.2326 5.84799 12.1205 5.84799 12C5.84799 11.8795 5.86724 11.7673 5.90574 11.6635C5.94424 11.5596 6.01033 11.4609 6.10399 11.3672L10.598 6.87298C10.7365 6.73465 10.908 6.66131 11.1125 6.65298C11.317 6.64465 11.4968 6.71798 11.652 6.87298C11.7968 7.01798 11.8692 7.19365 11.8692 7.39998C11.8692 7.60631 11.7968 7.78198 11.652 7.92698L7.59424 12ZM13.9442 12L18.002 16.073C18.1403 16.2115 18.2137 16.383 18.222 16.5875C18.2303 16.792 18.157 16.9718 18.002 17.127C17.857 17.2718 17.6813 17.3442 17.475 17.3442C17.2687 17.3442 17.093 17.2718 16.948 17.127L12.4537 12.6327C12.3602 12.5391 12.2942 12.4403 12.2557 12.3365C12.2172 12.2326 12.198 12.1205 12.198 12C12.198 11.8795 12.2172 11.7673 12.2557 11.6635C12.2942 11.5596 12.3602 11.4609 12.4537 11.3672L16.948 6.87298C17.0865 6.73465 17.258 6.66131 17.4625 6.65298C17.667 6.64465 17.8468 6.71798 18.002 6.87298C18.1468 7.01798 18.2192 7.19365 18.2192 7.39998C18.2192 7.60631 18.1468 7.78198 18.002 7.92698L13.9442 12Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};